import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../AuthContext";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import Select from "react-select";
import { LocationsContext } from "../../LocationsContext";
import "./ProfileSettings.css";

const ProfileSettings = () => {
  const { user } = useContext(AuthContext); // Get the user data from login
  const { cities, loading, error } = useContext(LocationsContext); // Get the locations data from context
  //const [profilePicture, setProfilePicture] = useState(null);
  const [userData, setUserData] = useState({
    profile_picture: "",
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    location_id: null,
  });

  // Local UI states for the select dropdowns
  const [selectedCity, setSelectedCity] = useState(null);
  //const [selectedRegion, setSelectedRegion] = useState('');
  //const [selectedCountry, setSelectedCountry] = useState('');

  // Prepare options for react-select
  const cityOptions = cities.map(loc => ({
    value: loc.id,
    label: `${loc.city} (${loc.post_code})`,
    region: loc.region,
    country: loc.country,
  }));

  // When a city is chosen, populate region & country & store location_id
  const handleCityChange = option => {
    setSelectedCity(option);
    //setSelectedRegion(option?.region || '');
    //setSelectedCountry(option?.country || '');
    setUserData(prev => ({
      ...prev,
      location_id: option ? option.value : null
    }));
  };

  useEffect(() => {
    if (user) {
      setUserData({
        profile_picture: user.profile_picture || "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541",
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email || "",
        phone_number: user.phone_number || "",
        location_id: user.location_id || null,
      });
    }
  }, [user]);

  useEffect(() => {
    if (!loading && user?.location_id) {
      const found = cities.find(c => c.id === user.location_id);
      if (found) {
        const opt = { value: found.id, label: `${found.city} (${found.post_code})`, region: found.region, country: found.country };
        setSelectedCity(opt);
        //setSelectedRegion(found.region);
        //setSelectedCountry(found.country);
        setUserData(prev => ({ ...prev, location_id: found.id }));
      }
    }
  }, [user, cities, loading]);

  /*const handlePictureChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        setProfilePicture(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };*/

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (phone) => {
    setUserData((prevData) => ({
      ...prevData,
      phone_number: phone || "", // Ensure an empty string if the input is cleared
    }));
  };

  // Persnoal info change
  const handleSave = async () => {

    // Samo lokacija je obvezna (in pogojno telefon/ime, če bi želel, a si rekel da ne)
    if (!userData.location_id) {
      Swal.fire({
        icon: "error",
        title: "Manjkajoči podatki",
        text: "Prosimo, izberite svojo lokacijo (Mesto).",
        confirmButtonText: "OK",
      });
      return;
    }

    // --- KONEC VALIDACIJE ---

    // Če je validacija uspešna, nadaljujemo s pošiljanjem podatkov.
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/${user.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify(userData), // Ni treba pošiljati posebej, ker je že vse v stanju
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Uspeh",
          text: "Podatke ste uspešno posodobili.",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Napaka",
          text: "Napaka pri posodabljanju podatkov. Prosimo, poskusite znova.",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  // Password change
  const handlePasswordChange = async () => {
    const currentPassword = userData.currentPassword;
    const newPassword = userData.newPassword || "";
    const confirmPassword = userData.confirmPassword || "";

    // Validate password inputs
    if (!newPassword || !confirmPassword) {
      Swal.fire("Error", "Please fill in both password fields.", "error");
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire("Error", "Passwords do not match.", "error");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      if (response.ok) {
        Swal.fire("Uspeh!", "Geslo je bilo uspešno spremenjeno!", "success");
      } else {
        Swal.fire("Napaka", "Napaka pri spreminjanju gesla", "error");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      Swal.fire("Error", "Failed to change password. Please try again", "error");
    }
  };

  return (
    <div className="profile_settings">
      <h2>Nastavitve profila</h2>
      <hr className="hr_prof_sett" />

      {/*<h3>Sprememba slike</h3>
      <div className="profile_picture_section">
        <label htmlFor="profile_picture_upload" className="profile_picture_label">
          <img
            src={profilePicture || userData.profile_picture}
            alt="Profile"
            className="profile_picture"
          />
        </label>
        <input
          type="file"
          id="profile_picture_upload"
          className="profile_picture_input"
          onChange={handlePictureChange}
          accept="image/*"
        />
      </div>

      <hr className="hr_prof_sett" /> */}

      <h3>Moji podatki</h3>
      <div className="personal_info">
        <div className="info_row">
          <label>
            Ime:
            <input
              type="text"
              name="first_name"
              value={userData.first_name || ""}
              onChange={handleInputChange}
              placeholder="Vnesite ime"
            // Odstranil sem 'required', da je lahko prazno
            />
          </label>
          <label>
            Priimek:
            <input
              type="text"
              name="last_name"
              value={userData.last_name || ""}
              onChange={handleInputChange}
              placeholder="Vnesite priimek"
            // Odstranil sem 'required'
            />
          </label>
        </div>

        <div className="info_row">
          <label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Email
              <div className="info-icon-container">
                ?
                <span className="tooltip-text">
                  Emaila ne morete spremeniti sami. Kontaktirajte nas za pomoč.
                </span>
              </div>
            </div>
            <input
              type="email"
              name="email"
              value={userData.email || ""}
              readOnly
              className="read-only-input"
            />
          </label>
          <label>
            Telefon:
            <PhoneInput
              international
              defaultCountry="SI"
              value={userData.phone_number || ""}
              onChange={handlePhoneChange}
              placeholder="Vnesite telefon"
            // Odstranil sem 'required'
            />
          </label>
        </div>
        <div className="info_row">
          <label>
            Mesto:
            <Select
              className="city_select"
              classNamePrefix="custom-react-select_city"
              options={cityOptions}
              isClearable
              isSearchable
              isLoading={loading}
              value={selectedCity}
              onChange={handleCityChange}
              placeholder="Izberite mesto"
            />
          </label>
          <label>
            Regija:
            <input
              type="text"
              name="region"
              //value={selectedRegion}
              value={selectedCity?.region || ''}
              readOnly
              placeholder="Regija"
            />
          </label>
          <label>
            Država:
            <input
              type="text"
              name="country"
              //value={selectedCountry}
              value={selectedCity?.country || ''}
              readOnly
              placeholder="Država"
            />
          </label>
        </div>

        <button className="btn btn-danger mx-3 save_changes_button" onClick={handleSave}>
          Shrani
        </button>

      </div>

      <hr className="hr_prof_sett" />

      <h3>Ponastavitev gesla</h3>
      <div className="password_reset">
        <label>
          Staro geslo:
          <input
            type="password"
            name="currentPassword"
            value={userData.currentPassword || ""}
            onChange={handleInputChange}
            placeholder="Vnesite novo geslo"
            required
          />
        </label>
        <label>
          Novo geslo:
          <input
            type="password"
            name="newPassword"
            value={userData.newPassword || ""}
            onChange={handleInputChange}
            placeholder="Vnesite novo geslo"
            required
          />
        </label>
        <label>
          Potrditev gesla:
          <input
            type="password"
            name="confirmPassword"
            value={userData.confirmPassword || ""}
            onChange={handleInputChange}
            placeholder="Potrdite geslo"
          />
        </label>
        <button className="btn btn-danger mx-3 change_password_button" onClick={handlePasswordChange}>
          Spremeni geslo
        </button>
      </div>
    </div>
  );
};

export default ProfileSettings;